function bookManagementLink(username, readingStatusId, section = null) {
    if (!username || !readingStatusId) return '';
    const query = new URLSearchParams({ manage: String(readingStatusId) });
    if (section === 'collections') query.set('section', 'collections');
    return `/account/u/${encodeURIComponent(username)}/library?${query.toString()}`;
}

module.exports = { bookManagementLink };
